// import request from '@/utils/request'
import { get, post,put,remove } from '@/utils/http.js'

// 查询调度日志列表
// export function listJobLog(query) {
//   return request({
//     url: '/monitor/jobLog/list',
//     method: 'get',
//     params: query
//   })
// }
export const listJobLog = (query) => get('/monitor/jobLog/list/' ,query);

// 删除调度日志
// export function delJobLog(jobLogId) {
//   return request({
//     url: '/monitor/jobLog/' + jobLogId,
//     method: 'delete'
//   })
// }
export const delJobLog = (jobLogId) => remove( '/system/menu/' + jobLogId);

// 清空调度日志
// export function cleanJobLog() {
//   return request({
//     url: '/monitor/jobLog/clean',
//     method: 'delete'
//   })
// }
export const cleanJobLog = () => remove( '/monitor/jobLog/clean' );

// 导出调度日志
// export function exportJobLog(query) {
//   return request({
//     url: '/monitor/jobLog/export',
//     method: 'get',
//     params: query
//   })
// }
export const exportJobLog = (query) => get('/monitor/jobLog/list/' ,query);
